<template>
  <div>
    <b-modal class="fixedModal" ref="myModal" size="lg" id="modal1" :title="'Info '+localType" centered
             :hide-footer="true" @hidden="onHidden">
      <template v-if="localType==='comercial'">
        <b-row>
          <!-- <b-col>
              <p style="margin-bottom:0px;"><img src="@/assets/img/icons/1.png" alt="Clientes comerciales"> Clientes comerciales</p>
              <p style="margin-bottom:0px;"><img src="@/assets/img/icons/6.png" alt="Alojamientos"> Alojamientos</p>
              <p style="margin-bottom:0px;"><img src="@/assets/img/icons/2.png" alt="C. comerciales"> C. comerciales</p>
              <p style="margin-bottom:0px;"><img src="@/assets/img/icons/4.png" alt="C. deportivos"> C. deportivos</p>
              <p style="margin-bottom:0px;"><img src="@/assets/img/icons/3.png" alt="C. educativos"> C. educativos</p>
              <p style="margin-bottom:0px;"><img src="@/assets/img/icons/13.png" alt="Edificios singulares"> Edificios singulares</p>
              <p style="margin-bottom:0px;"><img src="@/assets/img/icons/12.png" alt="Flotas GNV"> Flotas GNV</p>
              <p style="margin-bottom:0px;"><img src="@/assets/img/icons/15.png" alt="Gas renovable"> Gas renovable</p>
              <p style="margin-bottom:0px;"><img src="@/assets/img/icons/14.png" alt="Industriasb"> Industriasb</p>
              <p style="margin-bottom:0px;"><img src="@/assets/img/icons/7.png" alt="Lavanderías"> Lavanderías</p>
              <p style="margin-bottom:0px;"><img src="@/assets/img/icons/8.png" alt="Panaderías"> Panaderías</p>
              <p style="margin-bottom:0px;"><img src="@/assets/img/icons/10.png" alt="Restauracón"> Restauracón</p>
              <p style="margin-bottom:0px;"><img src="@/assets/img/icons/5.png" alt="Salud"> Salud</p>
              <p style="margin-bottom:0px;"><img src="@/assets/img/icons/11.png" alt="Talleres"> Talleres</p>
          </b-col> -->
          <b-col>
            <p><span class="square cliente"></span> "Ya es cliente"</p>
            <p><span class="square con-gas"></span> Potencial "Con gas en finca"</p>
            <p><span class="square sin-gas"></span> Potencial "Sin gas en finca"</p>
            <p><span class="square desconocido"></span> Potencial "Gas en finca desconocido"</p>
          </b-col>
        </b-row>
      </template>
      <template v-else-if="localType==='caldera'">
        <b-row>
          <b-col>
            <p><strong>Tipo suministro</strong></p>
            <p><span class="square"></span>Finca con caldera principal</p>
            <p><span class="circle"></span>Finca suministrada</p>
            <p><strong>Tipo Servicio</strong></p>
            <p><img src="@/assets/img/icons/calefaccion.png" alt="Calefaccion"> Calefacción</p>
            <p><img src="@/assets/img/icons/acs.png" alt="ACS"> ACS</p>
            <p><img src="@/assets/img/icons/calefaccion-acs.png" alt="Calefaccion y ACS"> Calefacción y ACS</p>
          </b-col>
          <b-col>
            <p><span class="square cliente"></span> "Ya es cliente"</p>
            <p><span class="square con-gas"></span> Potencial "Con gas en finca"</p>
            <p><span class="square sin-gas"></span> Potencial "Sin gas en finca"</p>
            <p><span class="square desconocido"></span> Potencial "Gas en finca desconocido"</p>
          </b-col>
        </b-row>
      </template>
      <template v-else-if="localType==='territorio'">
        <p>
          <img :src='"../../assets/img/icons/territorio_zonasgn.png"' height="15" width="15">
          <!-- <span class ="square" style="background:#ffffff"></span> -->
          Zonas Nedgia (Zoom 5-7)
        </p>
        <p>
          <img :src='"../../assets/img/icons/territorio_provincias.png"' height="15" width="15">
          <!-- <span class ="square" style="background:#e9b3eb"></span> -->
          Provincias (Zoom 8-10)
        </p>
        <p>
          <img :src='"../../assets/img/icons/territorio_municipios.png"' height="15" width="15">
          <!-- <span class ="square" style="background:#f0edda"></span> -->
          Municipios (Zoom 11-15)
        </p>
        <p>
          <img :src='"../../assets/img/icons/territorio_codigospostales.png"' height="15" width="15">
          <!-- <span class ="square" style="background:#f3cdca"></span> -->
          Códigos Postales (Zoom 14-18)
        </p>
        <p>
          <img :src='"../../assets/img/icons/territorio_areasnognd.png"' height="15" width="15">
          <!-- <span class ="square" style="background:#9af897"></span> -->
          Zonas no Nedgia (Zoom 5-21)
        </p>
        <p>
          <img :src='"../../assets/img/icons/territorio_secciones.png"' height="15" width="15">
          <!-- <span class ="square" style="background:#e9b3eb"></span> -->
          Secciones censales (Zoom 16-22)
        </p>
        <p>
          <img :src='"../../assets/img/icons/territorio_nucleos.png"' height="15" width="15">
          <!-- <span class ="square" style="background:#e9b3eb"></span> -->
          Núcleos urbanos (Zoom 11-13)
        </p>
        <p>
          <img :src='"../../assets/img/icons/territorio_exencionalta_borde.png"' height="15" width="15">
          <!-- <span class ="square" style="background:#9af897"></span> -->
          Exención derechos de alta (Zoom 11-17)
        </p>
        <p>
          <img :src='"../../assets/img/icons/territorio_exencioncanon_borde.png"' height="15" width="15">
          <!-- <span class ="square" style="background:#9af897"></span> -->
          Exención canon IRC (Zoom 11-17)
        </p>
        <!-- <p><span class ="square" style="background:#e9b3eb"></span>Parcelas Catastrales (Zoom 19-22)</p> -->
      </template>
      <template v-else-if="localType==='red'">
        <b-row>
          <b-col>
            <b-row>
              <b-col>
                <strong>Subtramos</strong>
              </b-col>
              <b-col>
                <strong>GN</strong>
              </b-col>
              <b-col>
                <strong>GLP</strong>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                Red APB
              </b-col>
              <b-col>
                <img src="@/assets/img/icons/red_apb.png" alt="Red APB GN">
              </b-col>
              <b-col>
                <img src="@/assets/img/icons/red_apb_glp.png" alt="Red APB GLP">
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                Red APA
              </b-col>
              <b-col>
                <img src="@/assets/img/icons/red_apa.png" alt="Red APA GN">
              </b-col>
              <b-col>
                <img src="@/assets/img/icons/red_apa_glp.png" alt="Red APA GLP">
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                Red MPB
              </b-col>
              <b-col>
                <img src="@/assets/img/icons/red_mpb.png" alt="Red MPB GN">
              </b-col>
              <b-col>
                <img src="@/assets/img/icons/red_mpb_glp.png" alt="Red MPB GLP">
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                Red MPA
              </b-col>
              <b-col>
                <img src="@/assets/img/icons/red_mpa.png" alt="Red MPA GN">
              </b-col>
              <b-col>
                <img src="@/assets/img/icons/red_mpa_glp.png" alt="Red MPA GLP">
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                Red BP
              </b-col>
              <b-col>
                <img src="@/assets/img/icons/red_bp.png" alt="Red BP GN">
              </b-col>
              <b-col>
                <img src="@/assets/img/icons/red_bp_glp.png" alt="Red BP GLP">
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row>
              <b-col>
                <strong>Acometidas</strong>
              </b-col>
              <b-col>

              </b-col>
            </b-row>
            <b-row>
              <b-col>
                Acometidas
              </b-col>
              <b-col>
                <span class="rectangle" style="background:#65ff00"></span>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                Acometidas enterradas
              </b-col>
              <b-col>
                <span class="rectangle" style="background:#ff9900"></span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col style="text-align:center;">
            <img src="@/assets/img/icons/red_en_servicio.png" alt="En servicio">
            <p>En servicio</p>
          </b-col>
          <b-col style="text-align:center;">
            <img src="@/assets/img/icons/red_en_construccion.png" alt="En construccion">
            <p>En construcción (con texto)</p>
          </b-col>
          <b-col style="text-align:center;">
            <img src="@/assets/img/icons/red_en_construccion.png" alt="En proyecto">
            <p>En proyecto (con texto)</p>
          </b-col>
        </b-row>
        <hr>
        <strong>Plantas GLP</strong>
        <b-row>
          <b-col style="text-align:center;">
            <img src="@/assets/img/icons/glp_glp_serv.png" alt="Instalación GLP - En servicio">
            <p>Instalación GLP - En servicio</p>
          </b-col>
          <b-col style="text-align:center;">
            <img src="@/assets/img/icons/glp_glp_fser.png" alt="Instalación GLP - Fuera de servicio">
            <p>Instalación GLP - Fuera de servicio</p>
          </b-col>
          <b-col style="text-align:center;">
            <img src="@/assets/img/icons/glp_botellas_serv.png" alt="Botellas GLP - En servicio">
            <p>Botellas GLP - En servicio</p>
          </b-col>
          <b-col style="text-align:center;">
            <img src="@/assets/img/icons/glp_botellas_fser.png" alt="Botellas GLP - Fuera de servicio">
            <p>Botellas GLP - Fuera de servicio</p>
          </b-col>
        </b-row>
        <hr>
        <strong>Plantas GNL</strong>
        <b-row>
          <b-col style="text-align:center;">
            <img src="@/assets/img/icons/gnl_gnl_serv.png" alt="Instalación GNL - En servicio">
            <p>Instalación GNL - En servicio</p>
          </b-col>
           <b-col style="text-align:center;">
            <img src="@/assets/img/icons/gnl_gnl_fser.png" alt="Instalación GNL - Fuera de servicio">
            <p>Instalación GNL - Fuera de servicio</p>
          </b-col>
        </b-row>
        <hr>
        <strong>Gasineras</strong>
        <b-row>
          <b-col style="text-align:center;">
            <img src="@/assets/img/icons/gasinera-gnl.png" alt="Gas Natural Licuado">
            <p>Gas Natural Licuado</p>
          </b-col>
          <b-col style="text-align:center;">
            <img src="@/assets/img/icons/gasinera-gnc.png" alt="Gas Natural Comprimido">
            <p>Gas Natural Comprimido</p>
          </b-col>
          <b-col style="text-align:center;">
            <img src="@/assets/img/icons/gasinera-gnc_gnl.png" alt="GNC-GNL">
            <p>GNC-GNL</p>
          </b-col>
        </b-row>
        <hr>
        <strong>Red inyeccion biogas - Caudal máximo (Nm3/h)</strong>
        <b-row>
          <b-col cols="2">
            &lt; 100
          </b-col>
          <b-col cols="2">
            <span class="rectangle" style="background:#fa1010"></span>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2">
            100 - 250
          </b-col>
          <b-col cols="2">
            <span class="rectangle" style="background:#d77008"></span>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2">
            250 - 500
          </b-col>
          <b-col cols="2">
            <span class="rectangle" style="background:#f4b81f"></span>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2">
            500 - 1000
          </b-col>
          <b-col cols="2">
            <span class="rectangle" style="background:#f8f404"></span>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2">
            1000 - 1500
          </b-col>
          <b-col cols="2">
            <span class="rectangle" style="background:#e2f81a"></span>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2">
            1500 - 2000
          </b-col>
          <b-col cols="2">
            <span class="rectangle" style="background:#bcf640"></span>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2">
            2000 - 3000
          </b-col>
          <b-col cols="2">
            <span class="rectangle" style="background:#93f321"></span>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2">
            &gt; 3000
          </b-col>
          <b-col cols="2">
            <span class="rectangle" style="background:#20f60d"></span>
          </b-col>
        </b-row>
      </template>
      <template v-if="localType==='residencial'">
        <div>
          <b-row>
            <b-col cols="3"></b-col>
            <b-col cols="2">Unifamiliares</b-col>
            <b-col cols="2">Bifamiliares</b-col>
            <b-col cols="2">Plurifamiliares</b-col>
          </b-row>
          <b-row>
            <b-col cols="3">Con activos - con potencial</b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/activas_uni_con.png" alt="Uni con activos" height="19" width="19">
            </b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/activas_bi_con.png" alt="Uni con activos" height="19" width="19">
            </b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/activas_pluri_con.png" alt="Uni con activos" height="19" width="19">
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">Con activos - sin potencial</b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/activas_uni_sin.png" alt="Uni con activos" height="19" width="19">
            </b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/activas_bi_sin.png" alt="Uni con activos" height="19" width="19">
            </b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/activas_pluri_sin.png" alt="Uni con activos" height="19" width="19">
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">Solo captados - con potencial</b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/captadas_uni_con.png" alt="Uni con activos" height="19" width="19">
            </b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/captadas_bi_con.png" alt="Uni con activos" height="19" width="19">
            </b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/captadas_pluri_con.png" alt="Uni con activos" height="19" width="19">
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">Solo captados - sin potencial</b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/captadas_uni_sin.png" alt="Uni con activos" height="19" width="19">
            </b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/captadas_bi_sin.png" alt="Uni con activos" height="19" width="19">
            </b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/captadas_pluri_sin.png" alt="Uni con activos" height="19" width="19">
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">Sin activos - con potencial</b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/no_activas_uni_con.png" alt="Uni con activos" height="19" width="19">
            </b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/no_activas_bi_con.png" alt="Uni con activos" height="19" width="19">
            </b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/no_activas_pluri_con.png" alt="Uni con activos" height="19" width="19">
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">Sin activos - sin potencial</b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/no_activas_uni_sin.png" alt="Uni con activos" height="19" width="19">
            </b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/no_activas_bi_sin.png" alt="Uni con activos" height="19" width="19">
            </b-col>
            <b-col cols="2">
              <img src="@/assets/img/icons/no_activas_pluri_sin.png" alt="Uni con activos" height="19" width="19">
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="3">Multifincas</b-col>
            <b-col offset-md="2">
              <img src="@/assets/img/icons/multifinca.png" alt="Multifincas" height="19" width="19">
            </b-col>
          </b-row>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<style>
.square {
  float: left;
  width: 15px;
  height: 15px;
  margin: 5px;
  border: 1px solid rgba(0, 0, 0, .8);
}

.circle {
  float: left;
  width: 15px;
  height: 15px;
  margin: 5px;
  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, .8);
}

.rectangle {
  float: left;
  width: 25px;
  height: 10px;
  margin: 5px;
  border: 1px solid rgba(0, 0, 0, .8);
}

.cliente {
  background: #4ff9ff;
}

.con-gas {
  background: #cefabc;
}

.sin-gas {
  background: #f6c166;
}

.desconocido {
  background: #bdb4b4;
}
</style>

<script>
export default {
  name: 'InfoPopUp',
  props: ['type'],
  data () {
    return {
      localType: null
    };
  },
  mounted: function () {
    if (typeof (this.type) === 'object') {
      this.localType = this.type.name.toLowerCase();
    } else {
      this.localType = this.type;
    }
    this.$refs.myModal.show();
  },
  methods: {
    onHidden: function () {
      this.$parent.showInfoPopUp = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/InfoPopUp.vue